function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 47,
  height: 47,
  rx: 7.5,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28 14h4.2c1 0 1.8.9 1.8 2v4h-2v-4h-4v-2ZM14 25v-2h20v2H14Zm14 9v-2h4v-4h2v4c0 1.1-.8 2-1.8 2H28Zm-12.2 0H20v-2h-4v-4h-2v4c0 1.1.8 2 1.8 2ZM20 16v-2h-4.2c-1 0-1.8.9-1.8 2v4h2v-4h4Z",
  fill: "#F8BD57"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(24 25)",
  fill: "#fff",
  d: "M0 0H16V16H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 38.3a5.3 5.3 0 1 0 0-10.6 5.3 5.3 0 0 0 0 10.6Zm.7-4.6a.7.7 0 1 1-1.4 0v-3.4a.7.7 0 0 1 1.4 0v3.4Zm0 2a.7.7 0 1 0-1.4 0 .7.7 0 0 0 1.4 0Z",
  fill: "#F8BD57"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 38.3a5.3 5.3 0 1 0 0-10.6 5.3 5.3 0 0 0 0 10.6Zm.7-4.6a.7.7 0 1 1-1.4 0v-3.4a.7.7 0 0 1 1.4 0v3.4Zm0 2a.7.7 0 1 0-1.4 0 .7.7 0 0 0 1.4 0Z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 47,
  height: 47,
  rx: 7.5,
  stroke: "#E6E6E6"
});

function SvgScannedPackageWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 27,
    width: 12,
    height: 12
  }, _ref6), _ref7);
}

var ForwardRef = React.forwardRef(SvgScannedPackageWarning);
export default __webpack_public_path__ + "static/media/scanned-package-warning.c8872827.svg";
export { ForwardRef as ReactComponent };